import { FC, useEffect, useRef, useState } from 'react';
import emptySchedule from 'assets/images/mock-schedule-empty.svg';
import { clsx } from 'clsx';
import { IMappedGroupScheduleWithoutDate } from 'entities/types';

import { getMinMaxTimes } from '../../lib/utils';
import { DateCard } from '../dateCard';
import { makeRows } from '../lib/utils/makeRows';
import { ITableScheduleProps } from '../models/types';
import {
  HeaderGroupRowTableSchedule,
  HeaderTeacherRowTableSchedule,
} from '../rowTableSchedule';

import styles from './styles.module.scss';

const EmptyRow: FC = () => {
  return (
    <div
      style={{
        width: '100%',
        padding: '10px 15px',
      }}
    >
      <img src={emptySchedule} alt="schedule is empty" />
    </div>
  );
};

export const TableScheduleWithoutDate: FC<ITableScheduleProps> = ({
  dataSchedule,
  dayNum,
  isGroupSchedule,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!sentinelRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsScrolled(!entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      },
    );

    observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  }, []);

  const evenRows = makeRows(dataSchedule, isGroupSchedule, true);
  const oddRows = makeRows(dataSchedule, isGroupSchedule, false);
  const times = getMinMaxTimes(
    dataSchedule as IMappedGroupScheduleWithoutDate[],
  );
  return (
    <div className={styles['table-schedule-container']}>
      {isGroupSchedule ? (
        <DateCard
          dayNum={dayNum}
          evenQuantity={evenRows.length}
          oddQuantity={oddRows.length}
          times={times}
        />
      ) : (
        <DateCard
          dayNum={dayNum}
          evenQuantity={evenRows.length}
          oddQuantity={oddRows.length}
          times={times}
        />
      )}
      <div ref={sentinelRef} className={styles['scroll-sentinel']} />
      <div className={styles['table-schedule']}>
        <div
          className={clsx(styles['table-schedule-header'], {
            [styles['table-schedule-header_scrolled']]: isScrolled,
          })}
        >
          {isGroupSchedule ? (
            <HeaderGroupRowTableSchedule isScrolled={isScrolled} />
          ) : (
            <HeaderTeacherRowTableSchedule isScrolled={isScrolled} />
          )}
        </div>
        {evenRows.length !== 0 ? evenRows : <EmptyRow />}
        <div
          style={{
            height: 1,
            width: '100%',
            background: 'var(--gray-light-25)',
            margin: '10px 0',
          }}
        ></div>
        {oddRows.length !== 0 ? oddRows : <EmptyRow />}
      </div>
    </div>
  );
};
